import { render, staticRenderFns } from "./Popovers.vue?vue&type=template&id=76c08125&"
import script from "./Popovers.vue?vue&type=script&lang=js&"
export * from "./Popovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports